import { Box, makeStyles } from "@material-ui/core";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { colors as themeColors } from "theme/constants";

import { SourceBreakdownChartAndTableProps } from "./SourceBreakdown";

const useStyles = makeStyles(theme => ({
  tooltipContainer: {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${themeColors.greyBackground}`,
    padding: theme.spacing(1),
    "& *": {
      fontSize: 16,
      color: theme.palette.primary.main,
      whiteSpace: "nowrap",
      margin: 0,
      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
      },
    },
    "& p, & li": {
      padding: 0,
      textAlign: "start",
    },
  },
}));

export function SourceBreakdownChart(props: SourceBreakdownChartAndTableProps) {
  const classes = useStyles();
  const { colors, data, pieChartHeight, totalValue } = props;

  const CustomTooltip = ({
    active,
    payload,
  }: {
    active: boolean;
    label: string;
    payload: any;
  }) => {
    return active ? (
      <Box className={classes.tooltipContainer}>
        <p>
          {Math.round((payload[0].value / totalValue) * 100)}% {payload[0].name}
        </p>
        {data
          .filter(
            s =>
              s.name === payload[0].name &&
              !!s.earning_details &&
              s.earning_details.length > 0,
          )
          .map(s => (
            <ul key={s.name}>
              {s.earning_details.map(d => {
                const percent = Math.round(
                  (d.earnings / payload[0].value) * 100,
                );
                return percent !== 0 ? (
                  <li key={d.name}>
                    {percent}% {d.name}
                  </li>
                ) : null;
              })}
            </ul>
          ))}
      </Box>
    ) : null;
  };

  return (
    // NOTE: the inline style is necessary to make rechart work here
    <div id="pie-chart-wrapper">
      <div style={{ maxWidth: 300, height: pieChartHeight || 300 }}>
        <ResponsiveContainer>
          <PieChart>
            <Tooltip content={CustomTooltip} />
            <Pie
              data={data}
              paddingAngle={1}
              dataKey="earnings"
              nameKey="name"
              outerRadius="80%"
              innerRadius="50%"
              isAnimationActive={false}
              fill={colors[0]}
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
